import React from 'react';
import { InfoPaper } from '@/common/components/surfaces/Paper';
import i18n from '@i18n';

export const ModuleFallback = ({ msg }) => (
    <div className={'px-20 py-20'}>
        <InfoPaper color={'pale-gray'}>{i18n(msg)}</InfoPaper>
    </div>
);
